module.exports = "<p>\r\n  mobile-force works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/customer-pre-login/mobile-force/mobile-force.component.html
// module id = ./src/app/components/customer-pre-login/mobile-force/mobile-force.component.html
// module chunks = main